// Diagnostic-only timing trail from the "why is the dashboard's LCP slow"
// investigation — kept as a no-op rather than deleted from the 33 call sites
// across App.js/Router.js/shop.js/Dashboard.js/Pricing.js/PlansComprison.js,
// since those checkpoints are still useful if a similar investigation is
// needed again. Silenced (2026) because the [PageLoad][PERF] line fired at
// every checkpoint on every page load and drowned out real console output.
// Uncomment the console.log below to re-enable the trail.
export function perfMark(label, extra) {
  // const t = performance.now().toFixed(0);
  // eslint-disable-next-line no-console
  // console.log(`[PageLoad][PERF] ${label} @ ${t}ms`, extra || '');
}
